module.exports = __webpack_public_path__ + "static/img/zjbd.5b27517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zjbd.png
// module id = y3nP
// module chunks = 1